<template>
<span>
  <span v-for="(doc, index) in documents" :key="`legal-document-link-${doc.id}`">
    <router-link :to="doc.route" target="_blank" class="font-medium underline">{{ doc.name }}</router-link>
    <template v-if="index < documents.length - 1">{{ index < documents.length - 2 ? ', ' : ' и ' }}</template>
  </span>
</span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      documents: 'settings/legalDocsLinks',
    }),
  },
}
</script>
